const FLIPKART_COINS_PAYMENT_METHOD_PREFIX = "pm_fk_coins";

export const FLIPKART_COINS_PAYMENT_METHOD_TEST_IDS = {
    CONTAINER: `${FLIPKART_COINS_PAYMENT_METHOD_PREFIX}_container`,
    ICON: `${FLIPKART_COINS_PAYMENT_METHOD_PREFIX}_icon`,
    NAME: `${FLIPKART_COINS_PAYMENT_METHOD_PREFIX}_name`,
    BALANCE: `${FLIPKART_COINS_PAYMENT_METHOD_PREFIX}_bal`,
    PAYMENT_AMOUNT: `${FLIPKART_COINS_PAYMENT_METHOD_PREFIX}_amount`,
    DISABLE_MESSAGE: `${FLIPKART_COINS_PAYMENT_METHOD_PREFIX}_disable_msg`,
    TICK: `${FLIPKART_COINS_PAYMENT_METHOD_PREFIX}_tick`,
    PAY_BUTTON: `${FLIPKART_COINS_PAYMENT_METHOD_PREFIX}_pay_btn`,
};
